import React, { useState, useEffect } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from '../contexts/auth-context'
import { FaPencilAlt, FaUser } from 'react-icons/fa'
import { PiFunnelSimpleBold } from 'react-icons/pi'
import { FaCreditCard } from 'react-icons/fa6'

import Footer from '../components/footer'
import Header from '../components/header'
import Enquiry from '@/components/home-view/enquiry'
import ProfileBanner from '../components/user-component/ProfileBanner'

function UserLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const { auth } = useContext(AuthContext)
  const isEditProfile = location.pathname === '/user/profile/edit'

  // Define tabs configuration
  const tabs = [
    {
      id: 'profile',
      label: 'Profile Information',
      icon: FaUser,
      path: '/user/profile',
    },
    {
      id: 'cards',
      label: 'Loyalty Cards',
      icon: FaCreditCard,
      path: '/user/cards',
    },
    {
      id: 'history',
      label: 'Loyalty Point History',
      icon: PiFunnelSimpleBold,
      path: '/user/history',
    },
    {
      id: 'rewards',
      label: null,
      icon: null,
      path: null,
    },
  ]

  // Set active tab based on current path
  const [activeTab, setActiveTab] = useState('profile')

  useEffect(() => {
    const path = location.pathname
    const currentTab = tabs.find((tab) => path.includes(tab.id))
    if (currentTab) {
      if (currentTab.label) {
        setActiveTab(currentTab.id)
        window.scrollTo(0, 0)
      }
    } else {
      // Default to profile if no match
      navigate('/user/profile')
      setActiveTab('profile')
    }
  }, [location.pathname])

  const handleTabClick = (tabId, path) => {
    setActiveTab(tabId)
    navigate(path)
  }

  return (
    <div className="flex flex-col min-h-[100dvh]">
      {/* Header */}
      <Header />
      <ProfileBanner /> {/* 👈 Displayed just below the header */}
      {/* Main content fills available space */}
      <div className="flex flex-1 bg-[#FFFAFA]  w-full">
        <div
          className="w-full max-w-7xl mx-auto bg-[#FFFAFA] p-4 md:pt-24 overflow-y-auto overflow-x-hidden 
          flex flex-col md:flex-row gap-4 
          "
        >
          {!isEditProfile && (
            <div
              className="w-full h-fit md:max-w-[270px]  "
              style={{
                border: '1px solid #F1E7F5',
              }}
            >
              <div
                className="min-h-[200px] flex items-center justify-center border-b border-[#F1E7F5] relative"
                style={{
                  background: "url('/customer-assets/UserMask.svg')",
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                {/* Pencil Edit Icon */}
                <button
                  onClick={() => navigate('/user/profile/edit')}
                  className="absolute top-0 right-0 p-2 bg-white shadow-sm cursor-pointer hover:bg-gray-50 hover:shadow-md transition-all duration-200 border border-gray-200"
                  title="Edit Profile"
                >
                  <FaPencilAlt className="w-3.5 h-3.5 text-gray-600" />
                </button>

                <div className="flex flex-col items-center">
                  <div className="w-[100px] h-[100px] rounded-full overflow-hidden border-2 border-gray-200">
                    <img
                      src={
                        auth?.user?.profile_image
                          ? `${import.meta.env.VITE_BASE_URL}${auth?.user?.profile_image}`
                          : '/customer-assets/User.svg'
                      }
                      alt="Profile"
                      className={`w-full h-full ${auth?.user?.profile_image ? 'object-contain' : ''} object-cover object-center`}
                    />
                  </div>
                  <h3 className="text-lg mt-2 font-semibold text-gray-900">
                    {auth?.user?.name || 'N/A'}
                  </h3>
                  <p className="text-sm text-[#433F4D]">{auth?.user?.email || 'N/A'}</p>
                </div>
              </div>

              {/* Tabs section */}
              <div className="flex flex-col">
                {tabs.map((tab) => {
                  if (!tab.label) return
                  return (
                    <button
                      key={tab.id}
                      onClick={() => handleTabClick(tab.id, tab.path)}
                      className={`flex items-center gap-3 bg-white px-6 py-4 cursor-pointer transition-colors border-b border-[#F1E7F5]
            ${
              activeTab === tab.id
                ? 'text-purple-600 bg-purple-50 '
                : 'text-[#4C2859] hover:bg-purple-50'
            }`}
                    >
                      <tab.icon
                        className={`w-5 h-5 ${
                          activeTab === tab.id ? 'text-purple-600' : 'text-gray-500'
                        }`}
                      />
                      <span className={activeTab === tab.id ? 'font-medium' : ''}>{tab.label}</span>
                    </button>
                  )
                })}
              </div>
            </div>
          )}

          <div
            className={` flex-1 ${isEditProfile ? '' : 'bg-[#FCF5FF]'} `}
            style={{
              border: isEditProfile ? '' : '1px solid #F1E7F5',
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
      {/* <div className="bg-[#FFFAFA] w-full">
        <div className="px-4 sm:px-6 md:px-12 xl:w-7xl m-auto py-12 sm:py-16 lg:py-[50px]">
          <div className="w-full">
            <Enquiry />
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  )
}

export default UserLayout
